import React from 'react';
import MeetingInfo from './MeetingInfo';
import CandidateDetails from './CandidateDetails';
import CastingReview from './CastingReview';
import ReviewLogsTable from './ReviewLogsTable';

const NonVideoAuditionSection = ({
    selectedApp,
    expired,
    talentAge,
    tp,
    handleViewCandidateProfile,
    hasPermission,
    isReviewSubmitted,
    hoverRating,
    setHoverRating,
    ratingStar,
    setRatingStar,
    reviewText,
    setReviewText,
    decision,
    setDecision,
    handleSaveReview,
    saveReviewLoading,
    fieldErrors,
    setFieldErrors
}) => {
    return (
        <div className="row g-4">
            <div className="col-12 col-lg-5 d-flex flex-column gap-4">
                <MeetingInfo selectedApp={selectedApp} expired={expired} />
                <CandidateDetails 
                    selectedApp={selectedApp} 
                    talentAge={talentAge} 
                    tp={tp} 
                    handleViewCandidateProfile={handleViewCandidateProfile} 
                />
            </div>

            <div className="col-12 col-lg-7 d-flex flex-column gap-4">
                <div 
                    className="card-dark p-3 p-md-4 rounded-3" 
                    style={{ 
                        background: 'linear-gradient(135deg, rgba(225, 6, 0, 0.08), #121212)', 
                        border: '1px solid rgba(225, 6, 0, 0.25)',
                        borderLeft: '4px solid #E10600'
                    }}
                >
                    <div className="d-flex align-items-center gap-2 text-danger fw-bold mb-2 fs-6">
                        📍 Audition Booking & Meeting Notice
                    </div>
                    <p className="text-white-50 small mb-0" style={{ lineHeight: '1.6', fontSize: '0.875rem' }}>
                        This candidate booked an interactive slot or face-to-face audition session. Please evaluate the candidate during the scheduled session and submit your rating & casting review below.
                    </p>
                </div>

                {hasPermission('Auditions', 'Action') && (
                    <div style={{ 
                        pointerEvents: isReviewSubmitted() ? 'none' : 'auto',
                        opacity: isReviewSubmitted() ? 0.65 : 1
                    }}>
                        <CastingReview 
                            bookingType={selectedApp?.bookingType}
                            hoverRating={hoverRating} 
                            setHoverRating={setHoverRating}
                            ratingStar={ratingStar} 
                            setRatingStar={setRatingStar}
                            reviewText={reviewText} 
                            setReviewText={setReviewText}
                            decision={decision} 
                            setDecision={setDecision}
                            handleSaveReview={handleSaveReview} 
                            saveReviewLoading={saveReviewLoading}
                            fieldErrors={fieldErrors} 
                            setFieldErrors={setFieldErrors}
                            disabled={isReviewSubmitted()}
                        />
                    </div>
                )}

                <ReviewLogsTable selectedApp={selectedApp} />
            </div>
        </div>
    );
};

export default NonVideoAuditionSection;
